import { defineMessages } from "react-intl";

export const columnMessages = defineMessages({
  name: {
    id: 'LwNa2M',
    defaultMessage: "Series",
    description: "series list column",
  },
  brand: {
    id: 'HMYI1Q',
    defaultMessage: "Brand",
    description: "series list column",
  },
  axes: {
    id: 'ZX9EUG',
    defaultMessage: "Questions asked",
    description: "series list column",
  },
  partitioningAxis: {
    id: 'MYwYMu',
    defaultMessage: "Variations split by",
    description: "series list column",
  },
  members: {
    id: 'g3yT3K',
    defaultMessage: "Products",
    description: "series list column",
  },
  status: {
    id: '+A7Szu',
    defaultMessage: "Status",
    description: "series list column",
  },
});

export const messages = defineMessages({
  createSeries: {
    id: '1Fdj6L',
    defaultMessage: "Create product series",
    description: "series list, button",
  },
  noSeries: {
    id: 'SOOpwz',
    defaultMessage: "No product series found",
    description: "series list, empty state",
  },
  searchPlaceholder: {
    id: 'psXh3c',
    defaultMessage: "Search product series",
    description: "series list, search field",
  },
});
